var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.302,
    height: 15.119,
    viewBox: "0 0 20.302 15.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube-circle",
    transform: "translate(-5.724 -7.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45375",
    "data-name": "Path 45375",
    d: "M19.9,6.526H8.905a3.953,3.953,0,0,0-3.905,4v5.624a3.951,3.951,0,0,0,3.905,4H19.9a3.953,3.953,0,0,0,3.905-4V10.523A3.951,3.951,0,0,0,19.9,6.526Zm-2.64,7.084L12.115,16.12a.2.2,0,0,1-.2-.012.216.216,0,0,1-.1-.18V10.751a.216.216,0,0,1,.1-.181.2.2,0,0,1,.2-.008l5.14,2.666a.216.216,0,0,1,0,.381Z",
    transform: "translate(1.474 1.923)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeCircle);
export default __webpack_public_path__ + "static/media/youtube-circle.65af51e5.svg";
export { ForwardRef as ReactComponent };